module.exports = __webpack_public_path__ + "static/media/1_002.9039c299.jpeg";